// Web search and the uploaded document library. Always on, rebuilt for every reply because it depends on the model
import type { Tool } from "ai"
import type { AssistantModule, ToolPolicy } from "@/lib/assistant/types"
import { makeWebTools, WEB_TOOL_LABELS, makeCorpusTools, CORPUS_TOOL_LABELS } from "./tools"
import { buildCorpusPromptSection } from "./prompt"

export { nativeSearchModel } from "./tools"
import type { Corpus } from "@/pages/dev/smart-cms/shared/corpus/db"

export const RESEARCH_TOOL_LABELS = { ...WEB_TOOL_LABELS, ...CORPUS_TOOL_LABELS }

export function makeResearchModule(ctx: {
  // A model with built-in web search brings its own tools
  nativeWebTools?: Record<string, Tool> | null
  modelId: string
  apiKeys: any
  getCorpusIds: () => string[]
  attachedCorpora: Corpus[]
}): AssistantModule {
  const webTools: Record<string, Tool> = ctx.nativeWebTools
    ?? makeWebTools({ exaKey: ctx.apiKeys?.exa, modelId: ctx.modelId, apiKeys: ctx.apiKeys })
  const corpusTools = makeCorpusTools({ getCorpusIds: ctx.getCorpusIds })
  const tools = { ...webTools, ...corpusTools }
  // Reading only: nothing here changes data
  const policies: Record<string, ToolPolicy> = Object.fromEntries(Object.keys(tools).map(n => [n, { kind: "read" as const }]))
  return {
    id: "research",
    title: "Web and documents",
    tools,
    policies,
    instructions: buildCorpusPromptSection(ctx.attachedCorpora) || undefined,
    labels: RESEARCH_TOOL_LABELS,
  }
}
